module.exports = __webpack_public_path__ + "static/media/prod8.a2955620.jpg";